export default defineNuxtPlugin(() => {
  const { initializeThemeSettings } = useThemeSettings();
  initializeThemeSettings();
});
